import { useCallback, useState } from "react";

const useTabNavigation = (defaultDisplayedDropdownMenu, initialOpenTab) => {
    const [activeTab, setActiveTab] = useState(initialOpenTab);
    const [displayedDropdownMenu, setDisplayedOptionDropdown] = useState(defaultDisplayedDropdownMenu);
    const [tabList, setTabList] = useState([]);

    const setDeterminedTabs = useCallback((determineTabs) => {
        setTabList(determineTabs);
    }, []);

    const changeActiveTab = (activeTab) => {
        setActiveTab(activeTab);
    };

    const toggleActiveContentCard = (isActiveTab) => {
        if (activeTab === isActiveTab) {
            setActiveTab(null);
        } else {
            setActiveTab(isActiveTab);
        }
    };

    const changeDisplayDropdownMenu = (updatedDisplayedDropdownMenu) => {
        setDisplayedOptionDropdown(updatedDisplayedDropdownMenu);
    };

    return {
        activeTab,
        displayedDropdownMenu,
        tabList,
        setDeterminedTabs,
        toggleActiveContentCard,
        changeDisplayDropdownMenu,
        changeActiveTab,
        setActiveTab,
    };
};

export default useTabNavigation;
